const configuredMeasurementId = String(process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-VM8CXTLE7X').trim();

export const GA_MEASUREMENT_ID = /^G-[A-Z0-9]+$/i.test(configuredMeasurementId)
    ? configuredMeasurementId.toUpperCase()
    : '';
